interface Props {
  onClick?: (e: React.MouseEvent) => void
}

// Cocoon egg logo from cocoon.org/img/cocoon-favicon-32x32.png
const COCOON_EGG =
  'data:image/png;base64,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'

const gradientStyle: React.CSSProperties = {
  background: 'linear-gradient(110deg, #A062FF 0%, #3088FF 30%, #61D8FF 60%, #A062FF 85%, #3088FF 100%)',
  backgroundSize: '200% 100%',
  animation: 'cocoon-flow 3s ease-in-out infinite',
  color: '#FFFFFF',
  boxShadow: '0 1px 6px rgba(48, 136, 255, 0.28)',
}

export default function CocoonBadge({ onClick }: Props) {
  const className =
    'inline-flex items-center gap-[3px] px-2 py-[3px] rounded-full text-[11px] font-semibold shrink-0'

  const icon = (
    <img
      src={COCOON_EGG}
      alt="Cocoon"
      width={12}
      height={12}
      style={{ flexShrink: 0, filter: 'brightness(0) invert(1)' }}
    />
  )

  if (onClick) {
    return (
      <button
        onClick={(e) => { e.stopPropagation(); onClick(e) }}
        className={`${className} active:opacity-70 transition-opacity`}
        style={gradientStyle}
      >
        {icon}
        Cocoon
      </button>
    )
  }

  return (
    <span className={className} style={gradientStyle}>
      {icon}
      Cocoon
    </span>
  )
}
